import React from "react";
import { Layout } from "antd";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "./auth.dashboard";
import PublicLayout from "../layouts/public.layout";

import HomePage from "../pages/home";
import SignupPage from "../pages/signup";
import LoginPage from "../pages/signin";

import TenantsPage from "../pages/tenants/index";
import LandlordsPage from "../pages/landlords";
import NotFoundPage from "../pages/404";
import PropertyPage from "../pages/landlord/property/setup";
import UnitPage from "../pages/landlord/property/unit";
import UnitsPage from "../pages/landlord/property/units";
import BankingPage from "../pages/landlord/property/banking";
import LeaseDetailsPage from "../pages/landlord/lease";
import ApplicantsPage from "../pages/landlord/applicants";
// import ApplicantsNewPage from "../pages/landlord/applicants/new";
// import ApplicantsScreenPage from "../pages/landlord/applicants/screened";
import ApplicationPage from "../pages/landlord/applicants/application";
import ApplicationOldPage from "../pages/landlord/applicants/application_old";
import MaintenancePage from "../pages/landlord/maintenance";
import PaymentsPage from "../pages/landlord/payments";
// import ProfilePage from "../pages/myprofile";
// import MySettings from "../pages/mysettings";

import EmailVerificationPage from "../pages/email-verfication";
// import FeedPage from "../pages/feed";
import AboutPage from "../pages/about";
import PrivacyPage from "../pages/about/privacy";
import TermsPage from "../pages/about/terms";
import RentalsPage from "../pages/rentals";
import RentalsListPage from "../pages/rentals/list";
import RentalsPropertyPage from "../pages/rentals/property";
import WaitVerifyPage from "../pages/wait-verify";

import ProtectedRoute from "../components/ProtectedRoute";
import LandlordDashboard from "../pages/landlord/dashboard";
import LandlordProfile from "../pages/landlord/profile";
import LandlordMyPosts from "../pages/landlord/mypost";
import ForgotPasswordPage from "../pages/forgot-password";

import LandlordSettingsPage from "../pages/landlord/settings";
import LandlordPhoneVerificationPage from "../pages/landlord/settings/phone-verification";
import LandlordPhoneChangePage from "../pages/landlord/settings/phone-change";
import LandlordApplicationDetail from "../pages/landlord/applicants/ApplicationDetail";

const { Content } = Layout;

const LandingLayout = () => {
  const LandlordLayout = () => {
    return (
      <ProtectedRoute>
        <AuthLayout>
          <Routes>
            <Route path="dashboard" element={<LandlordDashboard />} />
            <Route path="profile" element={<LandlordProfile />} />
            <Route path="settings" element={<LandlordSettingsPage />} />
            <Route
              path="phone-verification"
              element={<LandlordPhoneVerificationPage />}
            />
            <Route path="phone-change" element={<LandlordPhoneChangePage />} />

            <Route path="property/setup" element={<PropertyPage />} />
            <Route path="property/unit" element={<UnitPage />} />
            <Route path="property/unit/:id" element={<UnitPage />} />
            <Route path="property/units" element={<UnitsPage />} />
            <Route path="property/banking" element={<BankingPage />} />
            <Route path="applicants" element={<ApplicantsPage />} />
            <Route
              path="applicants/:applicationId"
              element={<LandlordApplicationDetail />}
            />
            {/* <Route path="applicants/new" element={<ApplicantsNewPage />} />
            <Route
              path="applicants/screened"
              element={<ApplicantsScreenPage />}
            /> */}
            <Route path="applicants/application" element={<ApplicationPage />} />
            <Route path="applicants/application_old" element={<ApplicationOldPage />} />
            <Route path="lease" element={<LeaseDetailsPage />} />
            <Route path="maintenance" element={<MaintenancePage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="myposts" element={<LandlordMyPosts />} />
          </Routes>
        </AuthLayout>
      </ProtectedRoute>
    );
  };

  return (
    <Layout>
      <Content>
        <Routes>
          <Route
            path="/"
            element={
              <PublicLayout>
                <HomePage />
              </PublicLayout>
            }
          />
          <Route
            path="/"
            element={
              <PublicLayout>
                <HomePage />
              </PublicLayout>
            }
          />
          {/* Auth Pages */}
          <Route
            path="/signup"
            element={
              <PublicLayout>
                <SignupPage />
              </PublicLayout>
            }
          />
          <Route
            path="/signin"
            element={
              <PublicLayout>
                <LoginPage />
              </PublicLayout>
            }
          />
          <Route
            path="/email-verification"
            element={
              <PublicLayout>
                <EmailVerificationPage />
              </PublicLayout>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicLayout>
                <ForgotPasswordPage />
              </PublicLayout>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicLayout>
                <ForgotPasswordPage />
              </PublicLayout>
            }
          />
          <Route path="/verify" element={<WaitVerifyPage />} />

          {/* Landlord Pages */}
          <Route path="/landlord/*" element={<LandlordLayout />} />

          <Route path="/home/" element={<HomePage />} />

          <Route
            path="/about"
            element={
              <PublicLayout>
                <AboutPage />
              </PublicLayout>
            }
          />
          <Route
            path="/about/privacy"
            element={
              <PublicLayout>
                <PrivacyPage />
              </PublicLayout>
            }
          />
          <Route
            path="/about/terms"
            element={
              <PublicLayout>
                <TermsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/tenants/"
            element={
              <PublicLayout>
                <TenantsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/landlords/"
            element={
              <PublicLayout>
                <LandlordsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/rentals"
            element={
              <PublicLayout>
                <RentalsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/rentals/list"
            element={
              <PublicLayout>
                <RentalsListPage />
              </PublicLayout>
            }
          />
          <Route
            path="/rentals/property/:ownerId/:id"
            element={
              <PublicLayout>
                <RentalsPropertyPage />
              </PublicLayout>
            }
          />
          {/* <Route
            path="/:username"
            element={
              <PublicLayout>
                <ProfilePage />
              </PublicLayout>
            }
          /> */}
          {/* <Route
            path="/:username/settings"
            element={
              <PublicLayout>
                <MySettings />
              </PublicLayout>
            }
          /> */}
          <Route
            path="/rentals"
            element={
              <PublicLayout>
                <RentalsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/rentals/list"
            element={
              <PublicLayout>
                <RentalsListPage />
              </PublicLayout>
            }
          />
          <Route
            path="/rentals/property"
            element={
              <PublicLayout>
                <RentalsPropertyPage />
              </PublicLayout>
            }
          />
          {/* <Route
            path="/:username"
            element={
              <PublicLayout>
                <ProfilePage />
              </PublicLayout>
            }
          /> */}
          {/* <Route
            path="/:username/settings"
            element={
              <PublicLayout>
                <MySettings />
              </PublicLayout>
            }
          /> */}
          {/* <Route path="/:username/status/:id" element={<FeedPage/>}/> */}

          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default LandingLayout;
